"use client";

import { MessageSquareText } from "lucide-react";
import { useState } from "react";
import { usePathname } from "next/navigation";
import InquiryModal from "./InquiryModal";

const FloatingInquiry = () => {
  const [showModal, setShowModal] = useState(false);
  const pathname = usePathname();

  if (pathname === "/contact/") return null;
  if (pathname.match(/\/sou-packages\/[^\/]+\/$/)) return null;
  // if (pathname.match(/\/sou-hotels\/[^\/]+\/$/)) return null;

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="fixed bottom-30 md:bottom-22 right-4 z-50 bg-[#ea580c] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 hover:shadow-orange-500/50 group w-[60px] h-[60px] flex items-center justify-center cursor-pointer"
        aria-label="Send Inquiry"
      >
        <MessageSquareText className="w-7 h-7 group-hover:rotate-12 transition-transform" />
      </button>

      <InquiryModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="General Inquiry"
        subtitle="Have questions? We're here to help you plan your perfect trip."
      />
    </>
  );
};

export default FloatingInquiry;
